import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .map-wrapper {
    width: 403px;
  }

  .map-container {
    width: 403px;
    height: 100%;
    border-radius: 0 12px 12px 0;
  }

  .widgets-container {
    display: flex;
    border-radius: 12px;
    background-color: ${(props) => props.theme.colors.widget_background};
    overflow: hidden;
  }

  .driver-score {
    /* width: 100%; */
    /* height: 300px; */
  }

  .actions-wrapper {
    width: 100%;
    margin-left: 32px;
    display: flex;
    gap: 16px;

    .border-line {
      content: '';
      height: 44px;
      border-right: 1px solid ${(props) => props.theme.colors.outline};
    }

    .learn-face-status {
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 44px;
      width: 110px;
      padding: 9px;
      font-size: 13px;
      gap: 8px;
      background: ${(props) => props.theme.colors.widget_background};
      border-radius: 6px;
      cursor: default;
      pointer-events: auto;
      color: ${(props) => props.theme.colors.text};
    }

    .learn-face-recognized {
      color: ${(props) => props.theme.colors.green};
    }
    
    .learn-face-not-recognized {
      color: ${(props) => props.theme.colors.red};
    }
  }

  .sub-header {
    display: flex;
    justify-content: space-between;
  }
`;

const Widget = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  flex: 1;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  overflow: hidden;
`;

const Row = styled.div`
  display: flex;
  gap: 20px;
`;

export default { Wrapper, Widget, Row };
